<template>
  <div>
    <img src="../assets/newsbanner.jpg" class="img-fluid w-100" alt="newsbanner">
    <section class="feature-area">
      <div class="mbx">
        <div class="container">
          <div class="row">
            <div class="col-lg-9">
              <div class="nytit pull-left">新闻中心</div>
              <menu class="menu pull-left" id="menu">
<!--                <div class="pull-left paddingleft15"><router-link to="/" class="cur underline " >企业动态</router-link></div>-->
<!--                <div class="pull-left paddingleft15"><router-link to="/" class="underline text66">代理品牌动态</router-link></div>-->
<!--                <div class="pull-left paddingleft15"><router-link to="/" class="underline text66">行业资讯</router-link></div>-->
                <div class="pull-left paddingleft15"><a href="javascript:void(0);" class="underline text66" :class="{'cur':nav_status_1}" @click="changeTab(0)">企业动态</a></div>
                <div class="pull-left paddingleft15"><a href="javascript:void(0);" class="underline text66" :class="{'cur':nav_status_2}" @click="changeTab(1)">代理品牌动态</a></div>
                <div class="pull-left paddingleft15"><a href="javascript:void(0);" class="underline text66" :class="{'cur':nav_status_3}" @click="changeTab(2)">行业资讯</a></div>
              </menu>
            </div>
            <div class="col-lg-3">
              <div class="mbxwrap">
                <router-link to="/" class="underline">首页</router-link> <span>/</span>
                <em>新闻中心</em>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>

    <div class="nycon">
      <div class="container">
        <div class="news">
          <ul>
            <li v-for="(list,index) in news_list">
                  <div class="pic pull-left"><a href="javascript:void(0);" @click="toNewsDetails(list)"><img class="vcenter" :src="list.image" alt="" /></a></div>
                  <div class="ntxt pull-left">
                    <a href="javascript:void(0);"class="underline" @click="toNewsDetails(list)">{{list.title}}</a>
                    <p>{{list.desc}}</p>
                  </div>
                  <div class="date pull-right">
                    <span>{{list.updateTime}}</span>
                    <a href="javascript:void(0);" @click="toNewsDetails(list)"></a>
                  </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <section class="feature-area  paddingbottom30">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 ">
              <Pagination v-if="total != 0" style="float: right"
                          :page-no="pageNo"
                          :page-size="pageSize"
                          :total="total"
                          :continues="5"
                          @getPageNo="getPageNo"
              ></Pagination>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
  export default {
    data () {
      return {
        nav_status_1: JSON.parse(this.$_storage.getLocalStore("index")) == null ? true : JSON.parse(this.$_storage.getLocalStore("index")) == 0,
        nav_status_2: JSON.parse(this.$_storage.getLocalStore("index")) == null ? false : JSON.parse(this.$_storage.getLocalStore("index")) == 1,
        nav_status_3: JSON.parse(this.$_storage.getLocalStore("index")) == null ? false : JSON.parse(this.$_storage.getLocalStore("index")) == 2,
        news_list: [],
        pageSize: 5,
        pageNo: 1,
        total: 0,
        category: "",
        index: JSON.parse(this.$_storage.getLocalStore("index")) == null ? 0 : JSON.parse(this.$_storage.getLocalStore("index")),
      }
    },
    components: {
      Pagination,
    },
    methods:{
      changeTab(index){
        const vm = this;
        if(0 == index){
          vm.nav_status_1 = true;
          vm.nav_status_2 = false;
          vm.nav_status_3 = false;
          vm.$_storage.setLocalStore('index',0);
        }else if(1 == index){
          vm.nav_status_1 = false;
          vm.nav_status_2 = true;
          vm.nav_status_3 = false;
          vm.$_storage.setLocalStore('index',1);
        }else if(2 == index){
          vm.nav_status_1 = false;
          vm.nav_status_2 = false;
          vm.nav_status_3 = true;
          vm.$_storage.setLocalStore('index',2);
        }
        vm.getNews(index,1);
      },
      getNews(category, pageNo){
        const vm = this;
        vm.category = category;
        vm.pageNo = pageNo;
        vm.$_axios({
          method: 'post',
          url: '/mapis/news/getNews',
          data: {
            category: vm.category,
            pageNo: vm.pageNo,
            pageSize: vm.pageSize
          },
          needLogin: false,
        }).then((response) => {
          if (response.status === 200) {
            const responseData = response.data.data;
            vm.news_list = responseData.newsDtoList;
            vm.total = responseData.total;
          }
        });
      },

      getPageNo(pageNo) {
        const vm = this;
        vm.pageNo = pageNo;
        vm.getNews(vm.category, vm.pageNo);
      },

      //获取产品详情
      toNewsDetails(news){
        const vm = this;
        vm.$_storage.setLocalStore('news',news);
        vm.$router.push({name:'newsDetails'});
      },
    },
    mounted() {
      var vm = this;
      vm.getNews(vm.index,1);
    }
  }
</script>




// WEBPACK FOOTER //
// News.vue?6826ef3a